import React, {useRef} from "react"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {AllowedIncomingRtpColumns, IncomingRtpColumns} from "./IncomingRtp.types"
import {Resource} from "../../resources/common"
import {IncomingRealTimePayment} from "../../resources/incomingRealTimePayment"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import {IncomingRtpRow} from "./IncomingRtpRow"

interface IncomingRtpTableProps {
	incomingRtps: IncomingRealTimePayment[]
	includedColumns: AllowedIncomingRtpColumns[]
	isUsingPaging: boolean
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	refresh: () => void
	include?: Resource[]
	fullHeight?: boolean
	stickyAction?: boolean
}

export function IncomingRtpTable({
	incomingRtps,
	includedColumns,
	hasResults,
	isUsingPaging,
	hasPrev,
	hasNext,
	prev,
	next,
	include,
	fullHeight = true,
	stickyAction = true,
}: IncomingRtpTableProps) {
	const noContent = incomingRtps.length === 0
	const ref = useRef(null)
	const navigateWithListPath = useNavigateWithListPath()

	return (
		<div ref={ref} className={"incoming-rtp-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={stickyAction}
				noContentText={"No incoming RTP found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === IncomingRtpColumns.createdAt) {
								return <DataTableCell key={column[1]}>{column[1]}</DataTableCell>
							}

							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{incomingRtps.map((rtp) => (
						<IncomingRtpRow
							incomingRtp={rtp}
							key={rtp.id}
							include={include}
							includedColumns={includedColumns}
							onClick={() => navigateWithListPath(`/incoming-real-time-payments/${rtp.id}`)}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
			/>
		</div>
	)
}
